module.exports = __webpack_public_path__ + "img/4-2.5843d185.jpg";